import React from 'react';
import { cn } from '../../lib/cn';
import { AlertCircle, CheckCircle2, Info } from 'lucide-react';

const intents = {
  error: {
    icon: AlertCircle,
    wrapper: 'border-red-200 bg-red-50 text-red-800 dark:border-red-800/60 dark:bg-red-950/60 dark:text-red-200',
    badge: 'bg-red-500/90 text-white',
    title: 'Se produjo un error',
  },
  success: {
    icon: CheckCircle2,
    wrapper: 'border-emerald-200 bg-emerald-50 text-emerald-800 dark:border-emerald-800/60 dark:bg-emerald-950/60 dark:text-emerald-200',
    badge: 'bg-emerald-500/90 text-white',
    title: 'Acción completada',
  },
  info: {
    icon: Info,
    wrapper: 'border-blue-200 bg-blue-50 text-blue-800 dark:border-blue-800/60 dark:bg-blue-950/60 dark:text-blue-200',
    badge: 'bg-blue-500/90 text-white',
    title: 'Información',
  },
};

export default function StateMessage({ intent = 'info', title, description, actions, className }) {
  const variant = intents[intent] ?? intents.info;
  const Icon = variant.icon;

  return (
    <div className={cn('rounded-xl border px-6 py-5  transition-all', variant.wrapper, className)}>
      <div className="flex items-start gap-4">
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white/40 dark:bg-white/5">
          <Icon className="h-6 w-6" />
        </div>
        <div className="flex-1 space-y-2">
          <div className="flex flex-wrap items-center gap-2">
            <span className={cn('inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium uppercase tracking-wide', variant.badge)}>
              {intent}
            </span>
            <h3 className="text-base font-semibold">
              {title || variant.title}
            </h3>
          </div>
          {description && <p className="text-sm leading-relaxed opacity-90">{description}</p>}
          {actions && <div className="flex flex-wrap gap-2 pt-2">{actions}</div>}
        </div>
      </div>
    </div>
  );
}
